// extracted by mini-css-extract-plugin
export default {"wrapper":"SuccessFeedback_wrapper__qhv-f","container":"SuccessFeedback_container__AGt-m","thanks":"SuccessFeedback_thanks__YTsVD"};